export enum LoginTypeEnum {
  STAFF = "STAFF",
  STUDENT = "STUDENT",
}

export const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount)
  }